import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useHistory, useLocation, useNavigate } from 'react-router-dom';

const drawerWidth = 240;
const navItems = [
  {
    title: 'HOME',
    path: '/home',
  },
  {
    title: 'ABOUT US',
    path: '/aboutus',
  },
  {
    title: 'SOLUTIONS',
    path: '/solutions',
  },
  {
    title: 'SERVICES',
    path: '/services',
  },
  {
    title: 'CONTACT US',
    path: '/contactus',
  },
  {
    title: 'PARTNERS',
    path: '/partners',
  },
  {
    title: 'EVENT',
    path: '/event',
  },
];

function DrawerAppBar(props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [language, setlanguage] = React.useState('en');
  const navigate = useNavigate();
  const location = useLocation();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleLanguageChange = (event) => {
    // navigate('/th/home');

    const { pathname } = location;
    navigate(`/kh${pathname}`);

    setlanguage(event.target.value);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ backgroundColor: '#00001c', textAlign: 'center', height: '100%' }}>
      <div style={{ flexGrow: 1, flexDirection: 'row', display: 'flex', backgroundColor: 'transparent', padding: 30 }}>
        <img src="/assets/logo.png" alt="onet logo" height={40} />
      </div>
      <Divider />
      <List style={{ padding: 15, backgroundColor: 'transparent' }}>
        {navItems.map((item) => (
          <ListItem key={item.title} disablePadding>
            <ListItemButton href={item.path} sx={{ textAlign: 'left' }}>
              <Typography style={{ fontWeight: 300, fontSize: 12, color: 'white' }}>{item.title}</Typography>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{ display: 'flex', backgroundColor: 'transparent' }}>
      <CssBaseline />
      <AppBar
        component="nav"
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 150,
          background: `linear-gradient(rgba(0,0,54,1),transparent)`,
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ backgroundColor: 'transparent', maxWidth: 1200, width: '100%' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>

          <div style={{ flexGrow: 1, flexDirection: 'row', display: 'flex' }}>
            <Link href="/home">
              <img src="/assets/logo.png" alt="onet logo" height={40} />
            </Link>
          </div>

          <Box sx={{ display: { xs: 'none', md: 'block' } }}>
            {navItems.map((item) => (
              <Button
                key={item.title}
                href={item.path}
                sx={{ color: 'white', fontWeight: 300, fontSize: 14, marginRight: 2 }}
              >
                {item.title}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', backgroundColor: 'transparent', width: drawerWidth },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
    </Box>
  );
}

DrawerAppBar.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default DrawerAppBar;
